export const showOrderItemShipModeSelectionDisplay = (display) => {
    var $displayShipModeSelect = $('.shipModeSelect');

    $.each($displayShipModeSelect, function(index, val) {
    	display ? $(this).show() : $(this).hide();
    });
};
